export const isPrivateMode = process.env.VUE_APP_DOMAIN.startsWith(
  "shiroishi-syokuin"
);

export const isPublicMode = !isPrivateMode;
